export default __webpack_public_path__ + "./fonts/historico.4890205e.svg";